import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { store } from 'Models/Store';
import If from '../If/If';

export type uiLocation = 'frontend' | 'admin';

export interface ITopBarProps {
	/** The current location of the application */
	currentLocation: uiLocation;
}

/**
 * The Topbar component displays the topbar for super administrators to toggle between the frontend and the
 * admin backend. Admins have backend access but reach the admin screens through the frontend nav, so the bar
 * is deliberately hidden for them.
 */
class Topbar extends React.Component<ITopBarProps> {
	private buttonLink = ({ location }: { location: uiLocation }) => {
		if (location === 'admin') {
			return (
				<Link to="/" className="icon-right icon-arrow-right-up link-rm-txt-dec active">
					Frontend
				</Link>
			);
		}
		return (
			<Link to="/admin-backend" className="icon-right icon-arrow-right-up link-rm-txt-dec active">
				Admin
			</Link>
		);
	};

	public render() {
		const { currentLocation } = this.props;

		return (
			<If condition={store.isSuper}>
				<div className="admin__top-bar">
					<ul>
						<li>
							<this.buttonLink location={currentLocation} />
						</li>
					</ul>
				</div>
			</If>
		);
	}
}
export default observer(Topbar);
